import $ from 'jquery';
import showTemplateFlash from '../util/show_template_flash';
import { queryString } from '@/js/modules/query_params';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    if ($('body').is('#teams')) {
      $(document).on('ajax:success', '.dropdown-menu__link--resend-invitation', (_event, data) => {
        const message = `You have successfully re-sent an invitation to ${data.email}!`;

        if (document.body.hasAttribute('data-sidenav-layout')) {
          showTemplateFlash('team-notice', message);
        } else {
          $('.flash--notice').remove();
          $('.main').prepend(`<div class="flash flash--notice">${message}</div>`);
        }
      });

      const queryParams = queryString();
      const inviteDesigner = queryParams.invite_designer;
      if (inviteDesigner) {
        document.querySelector('.p-button--add-team-member').click();
      }
    }

    if ($('body').is('#teams-edit-role-permissions')) {
      const visiblePermissionCheckbox =
        '.role-permissions__checkbox-wrapper:visible .green-checkbox--permission';

      $(document).on('change', '.green-checkbox--enable-all-permissions', (e) => {
        $(e.target)
          .closest('.role-permissions-wrapper')
          .find(visiblePermissionCheckbox)
          .prop('checked', $(e.target).prop('checked'))
          .trigger('change');
      });

      $(document).on('change', '.green-checkbox--permission', (e) => {
        const $container = $(e.target).closest('.role-permissions-wrapper');
        $container
          .find('.green-checkbox--enable-all-permissions')
          .prop(
            'checked',
            $container.find(visiblePermissionCheckbox).length ===
              $container.find(`${visiblePermissionCheckbox}:checked`).length
          );
      });
    }
  });
});
